import { drop } from "~/tools/drop";
import { take } from "~/tools/take";

import type { GetImpulseFormInputSetter, ImpulseForm, ImpulseFormList } from ".";

function setFormElementsInput<TState extends ImpulseForm, TInitial extends GetImpulseFormInputSetter<TState>>(
	create: (input: TInitial, index: number) => TState,
	inputs: ReadonlyArray<TInitial>,
	list: ImpulseFormList<TState>,
): void {
	list.setElements((elements) => {
		for (const [index, item] of elements.entries()) {
			if (index < inputs.length) {
				item.setInput(inputs[index]);
			}
		}

		if (elements.length > inputs.length) {
			return take(elements, inputs.length);
		}

		if (elements.length < inputs.length) {
			const addedItems = drop(inputs, elements.length).map((item, index) => create(item, index));

			return [...elements, ...addedItems];
		}

		return elements;
	});
}

export { setFormElementsInput };
